import React, { useEffect, useState } from "react";
import Modal from "../../../../components/Modal/index";
import { Typography, Button } from "@mui/material";
import AddFromRepositoryTable from "../../../../components/CourseBuilder/AddFromRepositoryTable";
import { useTranslation } from "react-i18next";
import {
  useContentRepositoryItemTypes,
  useContentRepositoryItemCategories
} from "../../../../hooks/data/contentRepository";

const AddItemFromRepository = ({
  open,
  onClose,
  onAddItems,
  isSubmitting,
  shortCourseId,
  courseOrPolicy
}) => {
  const { itemTypes } = useContentRepositoryItemTypes(courseOrPolicy);
  const { itemCategories } = useContentRepositoryItemCategories();

  const [selectedRows, setSelectedRows] = useState([]);

  const { t } = useTranslation();

  const handleSelectedRowsChange = selectedRows => {
    setSelectedRows(selectedRows);
  };

  useEffect(() => {
    setSelectedRows([]);
  }, [open]);

  return (
    <Modal
      scrollable
      disableEnforceFocus
      showCloseIcon
      maxWidth="lg"
      fullWidth
      fillHeight
      contentMinHeight={"350px"}
      dialogTitle={
        <Typography variant="h4" color="textPrimary">
          {t("courseBuilder.addFromRepositoryModalTitle")}
        </Typography>
      }
      dialogContent={
        <AddFromRepositoryTable
          onSelectRows={handleSelectedRowsChange}
          excludedCourseSectionId={shortCourseId}
          itemTypes={itemTypes}
          itemCategories={itemCategories}
          courseOrPolicy={courseOrPolicy}
        />
      }
      dialogActions={
        <>
          <Button color="primary" disabled={isSubmitting} onClick={onClose}>
            {t("courseBuilder.addFromRepositoryCancelBtn")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => onAddItems(selectedRows)}
            disabled={selectedRows.length === 0}
          >
            {t("courseBuilder.addFromRepositorySaveBtn")}
          </Button>
        </>
      }
      open={open}
      onClose={onClose}
    />
  );
};

export default AddItemFromRepository;
